<div class="d-flex align-items-center justify-content-end position-relative container">
  <i *ngIf="showValidationIcon" 
     class="fas fa-info-circle text-danger mr-1 validation-icon" 
     [ngbTooltip]="validationMessage"
     tooltipClass="my-custom-class-additional-fields"
     placement="top"
     container="body">
  </i>
    <input 
    type="text" 
    class="border bg-white rounded text-renderer text-right flex-grow-1"
    [class]="cellClass"
    [ngClass]="{'border-danger': showValidationIcon}"
    [ngModel]="value" 
    (input)="handleInput($event)" 
    (focus)="handleFocus($event)" 
    (blur)="handleBlur($event)" 
    (keydown)="handleKeyDown($event)"
    [placeholder]="placeHolder"
    [maxlength]="maxLength"
    tabindex="0">
  
  
</div>
